import { useEffect, useRef } from 'react'
import { trackUpsellPopupView } from './upsellEventMap'

/**
 * Dispara evento de visualização sempre que um modal de upsell do projeto
 * (não Stripe) fica visível — ao abrir o fluxo, trocar de passo ou de aba.
 */
export function useUpsellEventMap({
  flow,
  campaignId,
  currentStep,
  activeTab,
  extra,
}) {
  const lastTrackedKeyRef = useRef(null)

  useEffect(() => {
    if (!currentStep) {
      lastTrackedKeyRef.current = null
      return
    }

    const tab = currentStep === 'ready' ? activeTab : undefined
    const trackingKey = `${flow}:${currentStep}:${tab ?? ''}`

    if (lastTrackedKeyRef.current === trackingKey) {
      return
    }

    lastTrackedKeyRef.current = trackingKey

    trackUpsellPopupView({
      flow,
      campaignId,
      step: currentStep,
      tab,
      extra,
    })
  }, [flow, campaignId, currentStep, activeTab, extra])
}
